<template>
  <div>
    <div class="b-full-table">
      <div class="b-full-table__row b-full-table__row-header">
        <div class="b-full-table__cell b-full-table__header-cell b-full-table__header-cell_date" :class="tableHeaderClass('convertedDate')" @click="sortEventsByKey('convertedDate')">
          {{ $t('CONTENT.events.event_date') }}
        </div>
        <div class="b-full-table__cell b-full-table__header-cell">{{ $t('CONTENT.events.event_integration_type') }}</div>
        <div class="b-full-table__cell b-full-table__header-cell">{{ $t('CONTENT.events.event_type') }}</div>
        <div class="b-full-table__cell b-full-table__header-cell">{{$t('CONTENT.events.event_comment')}}</div>
        <div class="b-full-table__cell b-full-table__header-cell b-full-table__cell_type_btn"></div>
      </div>
      <template v-for="(event) in sortedEvents">
        <div
          class="b-table__row b-full-table__row b-full-table__row--hover-off"
          :key="event.idInDB">
          <div class="b-full-table__cell b-full-table__cell_event_date">
            {{ event.convertedDate }}
            <span
              v-if="event.isCurrent"
            >({{ $t("CONTENT.contract.current_contract") }})</span>
          </div>
          <div class="b-full-table__cell">
            <span v-if="event.isIntegrationEvent">Событие из интеграции</span>
            <span v-else>Пользовательское событие</span>
          </div>
          <div class="b-full-table__cell">
            {{ event.translatedEventType }}
            <br/>
            <ul>
              <li v-for="command in event.commands" :key="command.idInDB">
                <span>— {{ $t(`CONTENT.events.${command.commandName}`) }}. </span>
                <template v-for="(assetDetail, index) in commandDetails(command)">
                  <span v-if="assetDetail.assetName !== undefined">{{ assetDetail.assetName }}. </span>
                  <span v-if="assetDetail.externalId !== undefined" class="external-id">
                    {{ $t('CONTENT.assets.externalId') }}: {{ assetDetail.externalId }}.</span>
                </template>
              </li>
            </ul>
            <div v-if="event.rateIsChanged" class="mt-1 ml-2">
              <span class="b-full-table__annotation">{{ $t('CONTENT.events.annotation') }}</span>
            </div>
          </div>
          <div v-if="!isReadOnlyMode" class="b-full-table__cell">
            <input
              id="event-comment"
              v-model="event.comments"
              data-cy="event-comment"
              type="text"
              class="b-input"
              name="event-comment"
              @change="changeComment(event)"/>
          </div>
          <div  v-if="!isReadOnlyMode" class="b-full-table__cell b-full-table__cell_type_btn b-full-table__cell_type_btn--content-center">
            <div v-if="applyButtonAvailableForEvent(event)">
              <button
                type="button"
                class="b-btn b-btn--text-green"
                :disabled="applyButtonDisabledForEvent(event)"
                @click="applyEvent(event)">{{ $t('CONTENT.events.apply') }}
              </button>
            </div>
            <div v-if="deleteButtonAvailableForEvent(event)">
              <button
                type="button"
                class="b-btn b-btn--text-red ml-2"
                :disabled="applyButtonDisabledForEvent(event)"
                @click="deleteEvent(event)">{{ $t('CONTENT.delete') }}
              </button>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import {mapGetters} from "vuex";
import lodash from "lodash";
import dateConverter from "../../../../utils/converters/date.converter";
import AddAssetComponent from '@/plugins/eventRegistry/models/commands/AddAssetComponent';
import ChangeIsPermanent from '@/plugins/eventRegistry/models/commands/ChangeIsPermanent';
import ChangeQuantity from '@/plugins/eventRegistry/models/commands/ChangeQuantity';
import ChangeRentDuration from '@/plugins/eventRegistry/models/commands/ChangeRentDuration';
import ChangeFirstPaymentDate from '@/plugins/eventRegistry/models/commands/ChangeFirstPaymentDate';
import SetExtension from '@/plugins/eventRegistry/models/commands/SetExtension';
import ChangePaymentStartDate from "@/plugins/eventRegistry/models/commands/ChangePaymentStartDate";
import SetBuyout from "@/plugins/eventRegistry/models/commands/SetBuyout";
import ChangeLiquidationValue from "@/plugins/eventRegistry/models/commands/ChangeLiquidationValue";
import ChangeRentRate from "@/plugins/eventRegistry/models/commands/ChangeRentRate";
import SetTermination from "@/plugins/eventRegistry/models/commands/SetTermination";
import AddPaymentParameters from "@/plugins/eventRegistry/models/commands/AddPaymentParameters";
import IndexationRefinement from "@/plugins/eventRegistry/models/commands/IndexationRefinement";
import PaymentDeletion from "@/plugins/eventRegistry/models/commands/PaymentDeletion";
import ChangePaymentEndDate from "@/plugins/eventRegistry/models/commands/ChangePaymentEndDate";
import ChangePaymentFrequency from "@/plugins/eventRegistry/models/commands/ChangePaymentFrequency";
import SetIndexation from "@/plugins/eventRegistry/models/commands/SetIndexation";
import SetDiscount from "@/plugins/eventRegistry/models/commands/SetDiscount";
import SetDevaluations from "@/plugins/eventRegistry/models/commands/SetDevaluations";
import ChangeLessors from '@/plugins/eventRegistry/models/commands/ChangeLessors';
import AddLessor from '@/plugins/eventRegistry/models/commands/AddLessor';
import LessorComponentShares from '../../../assetComponent/models/lessorComponentShares';
import ContractEventsMixin from './ContractEventsMixin';
import RemoveLessor from '../../models/commands/RemoveLessor';
import AddLessorComponentShare from '../../models/commands/AddLessorComponentShare';
import Payment from '../../../payment';
import PaymentParameters from '../../../assetComponent/models/PaymentParameters';
import EventRegistryAPI from '../../../../api/EventRegistryAPI';
import PaymentsCalculationsAPI from "@/plugins/paymentCalculations/api/PaymentsCalculationsAPI";
import DateWithoutTimeAPI from "../../../../api/DateWithoutTimeAPI";
import ContractAggregateAPI from "@/api/ContractAggregateAPI";

export default {
  mixins: [ContractEventsMixin],
  props: {
    contractId: {
      required: true,
      type: Number | String,
    },
  },
  data() {
    return {
      events: null,
      currentContactId: null,
      currentIndexForApplying: 0,
      localStoragePrefix: 'contract_events_',
      contractObj: null,
      allVersions: [],
      role: null,
      useRole: true,
      isReadOnlyMode: true,
    };
  },
  async created() {
    this.contractObj = _.cloneDeep(this.getCurrentContract);
    await this.$eventRegistryManager.loadIntegrationEvents(this.contractId);
    this.role = localStorage.getItem('role');
    if (this.role === 'Admin' || this.role === 'Operator') {
      this.isReadOnlyMode = false;
    }
    this.useRole = localStorage.getItem('useRole');
    const api = new PaymentsCalculationsAPI();
    this.allVersions = await api.getContractVersions(this.contractId);
  },
  computed: {
    ...mapGetters(['getContractConditionsState', 'getContractState', 'getCurrentContract', 'allCounterparties', 'getAssets', 'getContractAssetComponents']),
    ...mapGetters(['eventRegistryPlugin/getIndexOfAppliedEvent']),

    convertedEvents() {
      this.events = this.$store.state.eventRegistryPlugin.integrationEvents
        .filter(event => !event.isApplied)
      return this.events.map(event => {
        const convertedEvent = lodash.clone(event)
        convertedEvent.convertedDate = this.$d(dateConverter.convertToDate(convertedEvent.eventDate))
        convertedEvent.isCurrent = this.$route.query.eventId === convertedEvent.idInDB
        convertedEvent.translatedEventType = this.$t(`CONTENT.events.${convertedEvent.eventType}`)
        return convertedEvent
      })
    },
    isContractChangeConditions() {
      return this.getContractConditionsState;
    },
    indexOfApplyingEvent() {
      return this.$store.getters['eventRegistryPlugin/getIndexOfAppliedEvent'];
    },
    isContractEditState() {
      return this.getContractState;
    },
    currentLessors() {
      return this.allCounterparties
        .filter(counterparty => this.getCurrentContract.contract.lessorCounterpartyIds.includes(counterparty.idInDB))
    },
  },
  methods: {
    applyButtonDisabledForEvent(event) {
      return (this.isContractChangeConditions
        || this.isContractEditState)
    },
    applyEvent(event) {
      this.$store.commit("SET_CONTRACT_CHANGE_CONDITION_STATE", true);
      this.$store.commit("eventRegistryPlugin/addIntegrationEventDate", event.eventDate);
      this.$store.commit("eventRegistryPlugin/addIntegrationEventIdInDbToList", event.idInDB);

      event.commands.forEach((eventCommand) => {
        const command = this.createCommand(eventCommand, event.eventDate)
        if (command.commandName === 'AddLessor') this.applyAddLessorCommand(command)
        if (command.commandName === 'AddAssetComponent') this.applyAddAssetComponentCommand(command)
        if (command.commandName === 'AddLessorComponentShare') this.applyAddLessorComponentShareCommand(command)
        if (command.commandName === 'AddPaymentParameters') this.applyAddPaymentParametersCommand(command)
        this.$store.commit("eventRegistryPlugin/addOrUpdateCommand", command);
      })
      this.$store.commit("eventRegistryPlugin/increaseIndex");
    },
    async deleteEvent(event) {
      try {
        await new EventRegistryAPI().deleteIntegration(event.idInDB);
      } catch(e){
        this.error = e;
        this.onException(e);
        return
      }

      if (this.sortedEvents.length === 1 && this.useRole === 'false') {
        const contractId = this.getCurrentContract.contract.idInDB;
        const newStatus = 5;
        const requestData = { contractId, newStatus };
        console.log(requestData);
        await new ContractAggregateAPI().changeContractStatus(requestData);

      }
      this.$toast.success(this.$t('NOTIFY.event_deleted'));
      this.$parent.$emit('updateCurrentContract');
    },
    applyButtonAvailableForEvent(event) {
      const eventIndex = this.eventIndex(event)
      if (eventIndex === 0) {
        return true;
      } else if (eventIndex > 0) {
        if (event.convertedDate === this.convertedEvents[0].convertedDate && !event.isIntegrationEvent) {
          return true;
        } else {
          return false;
        }
      }
    },
    deleteButtonAvailableForEvent(event) {
      return !event.isIntegrationEvent;
    },
    createCommand(command, eventDate) {
      const commandData = JSON.parse(command.serialisedCommand);

      if (command.commandName === 'AddAssetComponent') {
        return new AddAssetComponent(commandData);
      }
      if (command.commandName === 'ChangePaymentFrequency') {
        return new ChangePaymentFrequency(commandData.paymentParametersId, commandData.newPaymentFrequency);
      }
      if (command.commandName === 'ChangeFirstPaymentDate') {
        return new ChangeFirstPaymentDate(commandData.paymentParametersId, commandData.newFirstPaymentDate, commandData.isLastPeriodDate);
      }
      if (command.commandName === 'ChangePaymentEndDate') {
        return new ChangePaymentEndDate(commandData.paymentParametersId, commandData.newEndDate);
      }
      if (command.commandName === 'PaymentDeletion') {
        return new PaymentDeletion(commandData.paymentParametersId);
      }
      if (command.commandName === 'SetIndexation') {
        return new SetIndexation(commandData.paymentParametersId, commandData.newIndexation, commandData.currentIndexationName);
      }
      if (command.commandName === 'SetDevaluations') {
        return new SetDevaluations(commandData.assetComponentId, commandData.newDevaluations, commandData.id);
      }
      if (command.commandName === 'SetDiscount') {
        return new SetDiscount(commandData.paymentParametersId, commandData.newDiscount);
      }
      if (command.commandName === 'IndexationRefinement') {
        return new IndexationRefinement(
          commandData.paymentParametersId,
          commandData.newRate,
          commandData.needToUpdateDiscountRate,
          commandData.newFirstIndexationDate,
        );
      }
      if (command.commandName === 'AddPaymentParameters') {
        return new AddPaymentParameters(commandData);
      }
      if (command.commandName === 'ChangeRentRate') {
        return new ChangeRentRate(commandData.paymentParametersId, commandData.newRate);
      }
      if (command.commandName === 'SetTermination') {
        return new SetTermination(commandData.assetComponentId, commandData.termination);
      }
      if (command.commandName === 'ChangeLiquidationValue') {
        return new ChangeLiquidationValue(commandData.assetComponentId, commandData.newLiquidationValue);
      }
      if (command.commandName === 'SetBuyout') {
        return new SetBuyout(commandData.assetComponentId, commandData.buyout);
      }
      if (command.commandName === 'ChangePaymentStartDate') {
        return new ChangePaymentStartDate(commandData.paymentParametersId, commandData.newStartDate);
      }
      if (command.commandName === 'ChangeQuantity') {
        return new ChangeQuantity(commandData.assetComponentId, commandData.newQuantity);
      }
      if (command.commandName === 'ChangeIsPermanent') {
        return new ChangeIsPermanent(commandData.assetComponentId, commandData.newIsPermanent);
      }
      if (command.commandName === 'ChangeRentDuration') {
        return new ChangeRentDuration(commandData.assetComponentId, commandData.newEndDate);
      }
      if (command.commandName === 'SetExtension') {
        return new SetExtension(commandData.assetComponentId, commandData.extension);
      }
      if (command.commandName === 'AddLessor') {
        return new AddLessor(commandData.newLessorComponentShares,
          commandData.newPaymentParameters,
          commandData.newPaymentsRates,
          dateConverter.convertToDate(eventDate))
      }
      if (command.commandName === 'ChangeLessors') {
        return new ChangeLessors(commandData.changedLessorsIds)
      }

      if (command.commandName === 'RemoveLessor') {
        return new RemoveLessor(commandData.contractId, commandData.removedLessorId, commandData.newPaymentsRates)
      }

      if (command.commandName === 'AddLessorComponentShare') {
        return new AddLessorComponentShare(
          commandData.id,
          commandData.externalId,
          commandData.assetComponentId,
          commandData.lessorId,
          commandData.startDateDay,
          commandData.startDateMonth,
          commandData.startDateYear,
          commandData.endDateDay,
          commandData.endDateMonth,
          commandData.endDateYear)
      }

      console.error('Неизвестное название команды', command.commandName);
    },
    applyAddAssetComponentCommand(command) {
      command.assetComponent.lessorComponentShares = []
      command.assetComponent.paymentsParameters = [];
      command.assetComponent.manualChartPayments = [];
      command.assetComponent.expenses = [];
      command.assetComponent.devaluations = [];
      command.assetComponent.idInDB = command.assetComponent.id;

      if (command.assetComponent.extensionJson) {
        command.assetComponent.extension = command.assetComponent.extensionJson;
      } else {
        command.assetComponent.extension = null;
      }

      if (!command.assetComponent.termination) command.assetComponent.termination = null
      if (!command.assetComponent.buyout) command.assetComponent.buyout = null

      command.assetComponent.startDate = `${command.assetComponent.startDateDay}/${command.assetComponent.startDateMonth}/${command.assetComponent.startDateYear}/LeaseProDateWithoutTime`;
      command.assetComponent.endDate = `${command.assetComponent.endDateDay}/${command.assetComponent.endDateMonth}/${command.assetComponent.endDateYear}/LeaseProDateWithoutTime`;

      this.saveNewAssetComponent(command.assetComponent)
    },
    saveNewAssetComponent(assetComponent) {
      assetComponent.lessorComponentShares.forEach(lessorComponentShare => {
        lessorComponentShare.startDate = assetComponent.startDate
        lessorComponentShare.endDate = assetComponent.endDate
      })

      this.contractObj.assetComponents.push(assetComponent);
      this.$emit('updateAssetComponents', this.contractObj.assetComponents)
    },
    applyAddLessorCommand(command) {
      command.newLessorComponentShares
        .forEach(newLessorComponentShare => {
          const assetComponent = this.contractObj.assetComponents
            .find(ac => ac.idInDB === newLessorComponentShare.assetComponentId)

          if(assetComponent === undefined) throw 'wrong assetComponentId'

          const newShare = LessorComponentShares.createNew(
            newLessorComponentShare.lessorId,
            dateConverter.convertToString(command.eventDate),
            assetComponent.endDate,
          )

          newShare.idInDB = newLessorComponentShare.id

          command.newPaymentParameters.forEach(newPaymentParameters => {
            this.buildDateForPaymentParameters(newPaymentParameters)
            newShare.paymentsParameters.push(newPaymentParameters)
          })

          assetComponent.lessorComponentShares.push(newShare)
          this.$emit('updateAssetComponents', this.contractObj.assetComponents)
        });
     },
    applyAddLessorComponentShareCommand(command) {
      const assetComponent = this.contractObj.assetComponents
        .find(ac => ac.idInDB === command.assetComponentId)
      if(assetComponent === undefined) throw 'wrong assetComponentId'

      const newShare = LessorComponentShares.createNew(
        command.lessorId,
        dateConverter.convertToString(new Date(command.startDateDay, command.startDateMonth, command.startDateYear)),
        dateConverter.convertToString(new Date(command.endDateDay, command.endDateMonth, command.endDateYear)),
      )

      newShare.idInDB = command.id
      newShare.externalId = command.externalId
      assetComponent.lessorComponentShares.push(newShare)
      this.$emit('updateAssetComponents', this.contractObj.assetComponents)
      },
    applyAddPaymentParametersCommand(command) {
      const lessorComponentShare = this.contractObj.assetComponents
        .flatMap(assetComponent => assetComponent.lessorComponentShares)
        .find(LessorComponentShare => LessorComponentShare.idInDB === command.newPaymentParameters.lessorComponentShareId)

      if(lessorComponentShare === undefined) throw 'wrong lessorComponentShareId'

      this.buildDateForPaymentParameters(command.newPaymentParameters)
      const newPayment = new PaymentParameters.createFromData(command.newPaymentParameters)
      lessorComponentShare.paymentsParameters.push(newPayment)
    },
    changeComment(event) {
      const data = {
        idInDb: event.idInDB,
        comments: event.comments,
      }
      new EventRegistryAPI().updateNumberAndComments(data)
    },
    commandDetails(command) {
      const commandData = JSON.parse(command.serialisedCommand);
      let assets = [];

      if (commandData.assetId !== undefined) {
        const asset = this.getAssets.find(a => a.idInDB === commandData.assetId);
        if (asset) assets.push({assetName: asset.name, externalId: asset.externalId});
      } else if (commandData.assetComponentId !== undefined) {
        const asset = this.getContractAssetComponents[commandData.assetComponentId];
        if (asset) assets.push({assetName: asset.name, externalId: asset.externalId});
      } else if (commandData.lessorComponentShareId !== undefined) {

        this.contractObj.assetComponents.forEach(assetComponent => {
          assetComponent.lessorComponentShares.forEach(lessorComponentShare => {
            if (lessorComponentShare.idInDB === commandData.lessorComponentShareId) {
              assets.push({assetName: assetComponent.name, externalId: assetComponent.externalId});
            }
          });
        });
      } else if (commandData.paymentParametersId !== undefined) {
        this.contractObj.assetComponents.forEach(assetComponent => {
          assetComponent.lessorComponentShares.forEach(lessorComponentShare => {
            lessorComponentShare.paymentsParameters.forEach(paymentParameter => {
              if (paymentParameter.idInDB === commandData.paymentParametersId) {
                assets.push({assetName: assetComponent.name, externalId: assetComponent.externalId});
              }
            });
          });
        });
      } else if (commandData.newLessorComponentShares !== undefined) {
        const filteredAssetComponents = this.contractObj.assetComponents.filter(assetComponent => {
          return commandData.newLessorComponentShares.some(item => item.assetComponentId === assetComponent.idInDB)
        });
        filteredAssetComponents.forEach(x => assets.push({assetName: x.name, externalId: x.externalId}));
      } else if (commandData.changedLessorsIds !== undefined) {
        const filteredAssetComponents = this.contractObj.assetComponents.filter(assetComponent => {
          return commandData.changedLessorsIds.some(item => item.assetComponentId === assetComponent.idInDB)
        });
        filteredAssetComponents.forEach(x => assets.push({assetName: x.name, externalId: x.externalId}));
      } else if (commandData.removedLessorId !== undefined && this.allVersions.length !== 0) {
        const curentDirectoryEvent = this.events.find(event => event.commands.some(commandItem => commandItem === command));
        const preLastVersionAssetComponents = this.allVersions.find(v=>v.versionId === curentDirectoryEvent.idInDB);
        if (preLastVersionAssetComponents && preLastVersionAssetComponents.assetComponentLessors) {
          preLastVersionAssetComponents.assetComponentLessors.forEach(ac => {
            if (ac.lessorIds && ac.lessorIds.some(lessorId => commandData.removedLessorId === lessorId)) {
              assets.push({ assetName: ac.assetComponentName, externalId: ac.assetComponentExternalId });
            }
          });
        }
      }
      return assets;
    },
    buildDateForPaymentParameters(newPaymentParameters) {
      const startDate = dateConverter.convertToString(new Date(
        newPaymentParameters.startDateYear,
        newPaymentParameters.startDateMonth,
        newPaymentParameters.startDateDay))

      const endDate = dateConverter.convertToString(new Date(
        newPaymentParameters.endDateYear,
        newPaymentParameters.endDateMonth,
        newPaymentParameters.endDateDay))

      const firstPaymentDate = dateConverter.convertToString(new Date(
        newPaymentParameters.firstPaymentDateYear,
        newPaymentParameters.firstPaymentDateMonth,
        newPaymentParameters.firstPaymentDateDay))

      newPaymentParameters.startDate = startDate
      newPaymentParameters.endDate = endDate
      newPaymentParameters.firstPaymentDate = firstPaymentDate
    },
  }
}
</script>

<style scoped>
.external-id {
  color: #7d7d7d;
}
</style>
